import { getStorage } from "./storage";

export const getAccounts = async () => {
  const accounts = await getStorage("ACCOUNTS");
  const accountsArray = [];
  accounts &&
    accounts.forEach((account) => {
      accountsArray.push(account.AccountNumber);
    });
  return accountsArray;
};

export const getApplications = async () => {
  const departments = await getStorage("DEPARTMENTS");
  const applicationArray = [];
  departments[2].Applications.forEach((app) => {
    applicationArray.push(app.Name);
  });
  return applicationArray;
};

export const getDepartments = async () => {
  const departments = await getStorage("DEPARTMENTS");
  const departmentsArray = [];
  departments.forEach((dept) => {
    departmentsArray.push(dept.Name);
  });
  return departmentsArray;
};

export const getSelectedDepartmentFromAccount = (
  orgAppDetails,
  accountList
) => {
  let selectedDepartments = [];
  orgAppDetails.forEach((org) => {
    org.depts.forEach((dept) => {
      dept.deptAccounts.forEach((account) => {
        let accountIndex = accountList.findIndex(
          (acc) => acc === account.accountNumber
        );
        if (accountIndex >= 0) {
          selectedDepartments.push(dept);
        }
      });
    });
  });

  selectedDepartments.forEach((dept) => {
    dept.deptAccounts = getSelectedAccountsInTheDept(dept, accountList);
  });
  return selectedDepartments;
};

const getSelectedAccountsInTheDept = (dept, accountList) => {
  let accounts = [];
  dept.deptAccounts.forEach((account) => {
    if (accountList.findIndex((acc) => acc === account.accountNumber) >= 0) {
      accounts.push(account);
    }
  });
  return accounts;
};

export const getDepartmentName = async (deptId) => {
  const userData = await getStorage("USERDATA");
  const departments = userData && userData.Departments;
  const departmentsArray =
    departments && departments.filter((dept) => dept.ID === deptId);
  if (
    departmentsArray &&
    departmentsArray.length &&
    departmentsArray[0] &&
    departmentsArray[0].Name
  ) {
    return departmentsArray[0].Name;
  } else {
    return "Default";
  }
};

export const getAllAccounts = async () => {
  const accounts = await getStorage("ACCOUNTS");
  return accounts;
};
